var map = {
	"./advancedSearchService.ts": 5082,
	"./aiDocumentService.ts": 3053,
	"./alertService.ts": 6582,
	"./apiService.ts": 184,
	"./appStateService.ts": 9796,
	"./authenticationService.ts": 7936,
	"./autocompleteService.ts": 1116,
	"./availabilityService.ts": 2257,
	"./beaconService.ts": 2232,
	"./bxRecommenderService.ts": 5481,
	"./chatService.ts": 7802,
	"./citationService.ts": 407,
	"./citationTrailService.ts": 5681,
	"./cloudStorageService.ts": 9666,
	"./configService.ts": 914,
	"./courseReserveService.ts": 4613,
	"./customSectionsService.ts": 3293,
	"./dataService.ts": 9804,
	"./dateRangeService.ts": 8579,
	"./datepickerService.ts": 7474,
	"./diagnosticsService.ts": 1892,
	"./dialogService.ts": 4508,
	"./documentDetailService.ts": 7616,
	"./documentQueryService.ts": 4401,
	"./documentService.ts": 3215,
	"./emailService.ts": 7576,
	"./eventService.ts": 8568,
	"./externalPluginsService.ts": 4911,
	"./facetsService.ts": 6236,
	"./feedbackService.ts": 3205,
	"./flowService.ts": 5432,
	"./googleApiService.ts": 5187,
	"./hooksService.ts": 5036,
	"./journalCoverageDetailsService.ts": 8635,
	"./journalTitleService.ts": 9397,
	"./jsonldService.ts": 3234,
	"./linkService.ts": 4436,
	"./localizationService.ts": 3095,
	"./mediaQueryService.ts": 5072,
	"./menuManagerService.ts": 1978,
	"./metricsService.ts": 3831,
	"./microsoftApiService.ts": 7496,
	"./moreFacetsService.ts": 3899,
	"./publicNoteService.ts": 8915,
	"./quickFiltersService.ts": 5674,
	"./quickLookService.ts": 2488,
	"./recaptchaService.ts": 9171,
	"./relatedItemsService.ts": 4119,
	"./researchAssistantService.ts": 4201,
	"./resultsFeedPlugins/bestBetsPlugin.ts": 9373,
	"./resultsFeedPlugins/databaseRecommendationsPlugin.ts": 7082,
	"./resultsFeedPlugins/didYouMeanPlugin.ts": 7858,
	"./resultsFeedPlugins/documentSummariesPlugin.ts": 5234,
	"./resultsFeedPlugins/imagesRollupPlugin.ts": 7255,
	"./resultsFeedPlugins/newsRollupPlugin.ts": 5654,
	"./resultsFeedPlugins/noResultsPlugin.ts": 3850,
	"./resultsFeedPlugins/querySuggestionsPlugin.ts": 7394,
	"./resultsFeedPlugins/referencesRollupPlugin.ts": 8823,
	"./resultsFeedPlugins/searchInfoPlugin.ts": 4703,
	"./resultsFeedService.ts": 3010,
	"./resultsFeedServicePlugins.ts": 624,
	"./rtaAvailabilityService.ts": 7902,
	"./savedItemsService.ts": 6243,
	"./savedSearchService.ts": 5473,
	"./searchScopeService.ts": 7384,
	"./searchService.ts": 3964,
	"./shortenUrlService.ts": 6934,
	"./sierraService.ts": 4718,
	"./storeService.ts": 1403,
	"./summonUserService.ts": 4296,
	"./svgIconService.ts": 5341,
	"./topicService.ts": 6585,
	"./translationService.ts": 7137,
	"./urlService.ts": 4587,
	"./utilitiesService.ts": 7640,
	"./viewStateService.ts": 4234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6897;